import { useTranslation } from 'react-i18next';

/** Stands in for a screen until step 10 builds it. Text only through i18n. */
export function Placeholder({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();
  return (
    <main className="placeholder">
      <h1>{t(titleKey)}</h1>
    </main>
  );
}
